import React, { useState } from 'react';
import Footer from "./Footer";
import './HowToUsePage.css';

const HowToUsePage = () => {
  const [activeTab, setActiveTab] = useState('Predict');

  // Function to handle tab changes
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <>
      <section className="how-to-use-page m-3" style={{ paddingTop: '100px', paddingBottom: '100px' }}>
        <div className="container d-flex">
          {/* Sidebar Section */}
          <div className="sidebar">
            <ul className="sidebar-nav">
              <li className={`sidebar-item ${activeTab === 'Predict' ? 'active' : ''}`}>
                <button onClick={() => handleTabClick('Predict')}>Predict</button>
              </li>
              {/* <li className={`sidebar-item ${activeTab === 'Search' ? 'active' : ''}`}>
                <button onClick={() => handleTabClick('Search')}>Search</button>
              </li> */}
            </ul>
          </div>

          {/* Main Content Section */}
          <div className="main-content">
            <h2 className="text-center mb-3">How to Use 🛠</h2>
            <div className="instructions-container">
              {/* Predict Tab Content */}
              {activeTab === 'Predict' && (
                <>
                  <div className="instruction-card hover-effect">
                    <h3 className="instruction-title">Single Prediction</h3>
                    <p>
                      <strong>Enter SMILES:</strong> In the "Single Prediction" section, type or paste the SMILES string of the molecule you want to analyze.
                      <br />
                      <strong>Submit:</strong> Click the "Submit" button to initiate the prediction process.
                      <br />
                      <strong>View Results:</strong> The prediction results will be displayed at the bottom of the page, indicating whether the molecule is predicted to be umami or non-umami.
                    </p>
                  </div>
                  <div className="instruction-card hover-effect">
                    <h3 className="instruction-title">Batch Prediction</h3>
                    <p>
                      <strong>Prepare CSV File:</strong> Create a CSV file with a column named 'SMILES'. In this column, enter the SMILES strings of the molecules you want to analyze.
                      <br />
                      <strong>Upload CSV:</strong> Click the "Choose File" button to select the prepared CSV file.
                      <br />
                      <strong>Submit:</strong> Click the "Submit" button to start the batch prediction.
                      <br />
                      <strong>View Results:</strong> The prediction results will be displayed at the bottom of the page, indicating whether each molecule is predicted to be umami or non-umami.
                    </p>
                  </div>
                  <div className="instruction-card hover-effect">
                    <h3 className="instruction-title">Drawing Prediction</h3>
                    <p>
                      <strong>Draw Molecule:</strong> Use the drawing tool to sketch the molecule's structure.
                      <br />
                      <strong>Submit:</strong> Click the "Submit" button to initiate the prediction.
                      <br />
                      <strong>View Results:</strong> The prediction results will be displayed at the bottom of the page, indicating whether the molecule is predicted to be umami or non-umami.
                    </p>
                  </div>
                  <div className="instruction-card hover-effect">
                    <h3 className="instruction-title">MiniBatch Prediction</h3>
                    <p>
                      <strong>Enter SMILES:</strong> Provide the SMILES strings, one per line, in the input box.
                      <br />
                      <strong>Submit:</strong> Click the "Submit" button to start the mini-batch prediction.
                      <br />
                      <strong>View Results:</strong> The prediction results will be displayed at the bottom of the page, indicating whether each molecule is predicted to be umami or non-umami.
                    </p>
                  </div>
                </>
              )}

              {/* Search Tab Content */}
              {/* {activeTab === 'Search' && (
                <>
                  <div className="instruction-card hover-effect">
                    <h3 className="instruction-title">Single Prediction</h3>
                    <p>
                      <strong>Enter SMILES:</strong> In the "Single Prediction" section, type or paste the SMILES string of the molecule you want to analyze.
                      <br />
                      <strong>Submit:</strong> Click the "Submit" button to initiate the search process.
                      <br />
                      <strong>View Results:</strong> The results will be displayed in a table, showing various properties of the molecule, such as aromatic rings, hydrogen bond acceptors/donors, logP, molecular formula, molecular weight, rotatable bonds, and topological polar surface area.
                      <br />
                      <strong>Visualize Molecule:</strong> The predicted molecule image will also be shown, providing a visual representation of the structure.
                    </p>
                  </div>
                  <div className="instruction-card hover-effect">
                    <h3 className="instruction-title">Batch Prediction</h3>
                    <p>
                      <strong>Prepare CSV File:</strong> Create a CSV file with a column named 'SMILES'. In this column, enter the SMILES strings of the molecules you want to analyze.
                      <br />
                      <strong>Upload CSV:</strong> Click the "Choose File" button to select the prepared CSV file.
                      <br />
                      <strong>Submit:</strong> Click the "Submit" button to start the search.
                      <br />
                      <strong>View Results:</strong> The results will be displayed in small pages, with each page representing a molecule and its corresponding properties.
                    </p>
                  </div>
                  <div className="instruction-card hover-effect">
                    <h3 className="instruction-title">Drawing Prediction</h3>
                    <p>
                      <strong>Draw Molecule:</strong> Use the drawing tool to sketch the molecule's structure.
                      <br />
                      <strong>Submit:</strong> Click the "Submit" button to initiate the search.
                      <br />
                      <strong>View Results:</strong> The results will be displayed in a table, similar to the Single Prediction.
                    </p>
                  </div>
                  <div className="instruction-card hover-effect">
                    <h3 className="instruction-title">MiniBatch Prediction</h3>
                    <p>
                      <strong>Enter SMILES:</strong> Provide the SMILES strings, one per line, in the input box.
                      <br />
                      <strong>Submit:</strong> Click the "Submit" button to start the mini-batch search.
                      <br />
                      <strong>View Results:</strong> The results will be displayed in small pages, similar to the Single Prediction results.
                    </p>
                  </div>
                </>
              )} */}
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default HowToUsePage;